import apiClient from './api'

const BASE_PATH = '/admin/categories/hybrid/exclusions'

export default {
  list(page = 1, perPage = 100, q = '') {
    return apiClient.get(BASE_PATH, {
      params: { page, per_page: perPage, q: q || undefined },
    })
  },
  create(payload) {
    return apiClient.post(BASE_PATH, payload)
  },
  remove(id) {
    return apiClient.delete(`${BASE_PATH}/${encodeURIComponent(id)}`)
  },
}
